export default __webpack_public_path__ + "static/media/map-element-1.8ffe876b.svg";